class ShipmentWebSocketService {
    constructor() {
      this.socket = null;
      this.url = null;
      this.messageListeners = [];
    }
  
    connect(url) {
      if (this.socket) {
        this.disconnect();
      }
  
      this.url = url;
      console.log("🚀 Connecting to Shipment WebSocket:", url);
      this.socket = new WebSocket(url);
  
      this.socket.onopen = () => {
        console.log("✅ Shipment WebSocket Connected:", url);
      };
  
      this.socket.onerror = (error) => {
        console.error("🚨 Shipment WebSocket Error:", error);
      };
  
      this.socket.onclose = () => {
        this.socket = null;
        console.log("🔌 Shipment WebSocket Disconnected.");
      };
  
      this.socket.onmessage = (event) => {
        console.log("📩 Shipment WebSocket Message:", event.data);
        this.notifyListeners(event.data);
      };
    }
  
    disconnect() {
      if (this.socket) {
        this.socket.onclose = null;
        this.socket.close();
        this.socket = null;
        console.log("🛑 Shipment WebSocket Disconnected");
      }
    }
  
    sendMessage(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify(message));
        console.log("📤 Shipment WebSocket Message Sent:", message);
      } else {
        console.warn("⚠ WebSocket is not connected! Cannot send message.");
      }
    }
  
    onMessage(callback) {
      if (!this.messageListeners.includes(callback)) {
        this.messageListeners.push(callback);
      }
    }
  
    removeMessageListener(callback) {
      this.messageListeners = this.messageListeners.filter((cb) => cb !== callback);
    }
  
    notifyListeners(data) {
      this.messageListeners.forEach((callback) => callback(data));
    }
  }
  
  export default new ShipmentWebSocketService();
  